export const helpList = [
    {
        text: '为什么企业号码认证会被拒绝？',
        routerPath: '/help'
    },
    {
        text: '为什么企业/个人号码在号码申诉时会被拒绝？',
        routerPath: '/help'
    },
    {
        text: '企业号码认证如何收费？',
        routerPath: '/help'
    },
    {
        text: '提交联系信息后，什么时候会和我联系？',
        routerPath: '/help'
    },
    {
        text: '企业/个人号码申诉成功后，为什么百度搜索或通话时还会显示标记？',
        routerPath: '/help'
    }
];